import {Pipe, PipeTransform} from '@angular/core';
import {PeriodUtilService} from '../services/util/period-util.service';
import {Moment} from 'moment-timezone';


interface TimeAgoPipeOptions {
  abbreviated?: boolean;
  compact?: boolean;
}


@Pipe({
  name: 'timeAgo',
  standalone: false
})
export class TimeAgoPipe implements PipeTransform {

  constructor(private periodUtilService: PeriodUtilService) {}

  transform(pastDate: Moment, options?: TimeAgoPipeOptions): string {
    return options?.abbreviated
      ? this.periodUtilService.timeAgoAbbreviated(pastDate, !!options?.compact)
      : this.periodUtilService.timeAgo(pastDate, !!options?.compact);
  }
}
